import { DecisionState } from '@/models/games/blackjack2/enums/DecisionState';
import {
    BetSeatIndex,
    BetSeats,
    getEmptyBetSeatsInfo,
    getNewBetSeats,
} from '@/models/games/blackjack2/SeatPlayerInfo';
import { EntityState, PayloadAction } from '@reduxjs/toolkit';
import {
    UpdateInSeatPayload,
    UpdateSeatInfoPayload,
    UpdateSeatPayload,
    UpdateStepPayload,
} from './payload';
import { bj2SeatsAdapter } from './seatSlice';

const reset = (
    state: EntityState<BetSeats, number>,
    action: PayloadAction<number>
) => {
    bj2SeatsAdapter.updateOne(state, {
        id: action.payload,
        changes: getNewBetSeats(action.payload),
    });
};
const resetBet = (
    state: EntityState<BetSeats, number>,
    action: PayloadAction<number>
) => {
    const hostId = action.payload;
    const betSeat = state.entities[hostId] ?? getNewBetSeats(hostId);
    for (let i = 1; i <= 7; i++) {
        const sn = `Seat${i}` as BetSeatIndex;
        betSeat[sn].SeatBet = 0;
        betSeat[sn].BetBehind = 0;
        betSeat[sn].PairBet = 0;
        betSeat[sn].PreDecision = 0;
        betSeat[sn].IsSplit = false;
        betSeat[sn].IsInsurance = false;
        betSeat[sn].IsSurrender = false;
        betSeat[sn].DecisionState = DecisionState.NO_DECISION;
    }
    return bj2SeatsAdapter.updateOne(state, {
        id: action.payload,
        changes: betSeat,
    });
};
const clearSeat = (
    state: EntityState<BetSeats, number>,
    action: PayloadAction<UpdateSeatPayload>
) => {
    const hostId = action.payload.hostId;
    const betSeat = state.entities[hostId] ?? getNewBetSeats(hostId);
    const sn = `Seat${action.payload.seat}` as BetSeatIndex;
    const newSeatInfo = getEmptyBetSeatsInfo();
    if (JSON.stringify(betSeat[sn]) !== JSON.stringify(newSeatInfo)) {
        console.log('resetSeat:', sn, newSeatInfo);

        return bj2SeatsAdapter.updateOne(state, {
            id: action.payload.hostId,
            changes: {
                [sn]: newSeatInfo,
            },
        });
    } else {
        // console.log('resetSeat --same--', sn, newSeatInfo);
    }
};
const resetSeat = (
    state: EntityState<BetSeats, number>,
    action: PayloadAction<UpdateSeatPayload>
) => {
    const hostId = action.payload.hostId;
    const betSeat = state.entities[hostId] ?? getNewBetSeats(hostId);
    const sn = `Seat${action.payload.seat}` as BetSeatIndex;
    const newSeatInfo = {
        ...betSeat[sn],
        SeatBet: 0,
        BetBehind: 0,
        PairBet: 0,
        PreDecision: 0,
        IsSplit: false,
        IsInsurance: false,
        IsSurrender: false,
        DecisionState: DecisionState.NO_DECISION,
    };

    if (JSON.stringify(betSeat[sn]) !== JSON.stringify(newSeatInfo)) {
        console.log('resetSeat:', sn, newSeatInfo);

        return bj2SeatsAdapter.updateOne(state, {
            id: action.payload.hostId,
            changes: {
                [sn]: newSeatInfo,
            },
        });
    } else {
        // console.log('resetSeat --same--', sn, newSeatInfo);
    }
};
const updateSeatObject = (
    state: EntityState<BetSeats, number>,
    action: PayloadAction<UpdateSeatInfoPayload>
) => {
    const hostId = action.payload.hostId;
    const betSeat = state.entities[hostId] ?? getNewBetSeats(hostId);
    const sn = `Seat${action.payload.seat}` as BetSeatIndex;
    let newSeatInfo = {
        ...betSeat[sn],
        ...action.payload,
        ClearIfMe: undefined,
    };
    if (action.payload.ClearIfMe == true && betSeat[sn].IsMe) {
        newSeatInfo.SeatBet = 0;
    }
    if (JSON.stringify(betSeat[sn]) !== JSON.stringify(newSeatInfo)) {
        if (
            betSeat[sn].IsMe &&
            betSeat[sn].PlayerID == 0 &&
            newSeatInfo.PlayerID == 0 &&
            action.payload.IsMe
        ) {
            //pending success/fail self bet keep data
            console.log('handle data clear by server with pending bets');
        } else {
            return bj2SeatsAdapter.updateOne(state, {
                id: action.payload.hostId,
                changes: {
                    [sn]: newSeatInfo,
                },
            });
        }
    } else {
        // console.log('updateSeatObject --same--', sn, newSeatInfo);
    }
};
const updateDecisionStateStep = (
    state: EntityState<BetSeats, number>,
    action: PayloadAction<UpdateStepPayload>
) => {
    let step = action.payload.step;
    const hostId = action.payload.hostId;
    const betSeat = state.entities[hostId] ?? getNewBetSeats(hostId);
    if (betSeat.DecisionStateStep === action.payload.step) {
        step += '1';
    }
    bj2SeatsAdapter.updateOne(state, {
        id: hostId,
        changes: {
            DecisionStateStep: step,
        },
    });
};
const updateInSeatLastRound = (
    state: EntityState<BetSeats, number>,
    action: PayloadAction<UpdateInSeatPayload>
) => {
    bj2SeatsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            inSeatLastRound: action.payload.inSeat,
        },
    });
};
export const betSeatsReducer = {
    reset,
    resetBet,
    updateSeatObject,
    resetSeat,
    clearSeat,
    updateDecisionStateStep,
    updateInSeatLastRound,
};
